import { PDFPrintServiceFactory } from 'pdfjs-dist/legacy/web/pdf_viewer';
import { trackAdobeEvent } from '../trackers/adobe';
import { SUPPORTED_PRINT_CLASS } from '../../constants';
import { recordPdfPrint } from '../newRelicBrowserActions';

const printResolution = 220;

export default class PdfPrint {
  constructor() {
    this.delegate = null;
    this.dispatchPrintEvent = null;
    this.pdfViewer = null;
  }

  init(pdfViewer, dispatchPrintEvent) {
    this.pdfViewer = pdfViewer;
    this.dispatchPrintEvent = dispatchPrintEvent;

    window.addEventListener('beforeprint', this.beforePrint);
    window.addEventListener('afterprint', this.afterPrint);
    window.addEventListener('printReady', this.printReady);
    window.addEventListener('printError', this.printError);
  }

  cancel() {
    this.dispatchPrintEvent(false);

    this.afterPrint();
  }

  beforePrint = () => {
    const pagesOverview = this.pdfViewer.getPagesOverview();
    const printContainer = document.getElementById('printContainer');
    this.delegate = PDFPrintServiceFactory.instance.createPrintService(
      this.pdfViewer.pdfDocument,
      pagesOverview,
      printContainer,
      printResolution,
    );
    this.delegate.layout();

    document.body.classList.add(SUPPORTED_PRINT_CLASS);

    this.dispatchPrintEvent(true);

    trackAdobeEvent('contentPrint');
  }

  printReady = () => {
    this.dispatchPrintEvent(false);

    recordPdfPrint('Success', null);
  }

  printError = (error) => {
    this.dispatchPrintEvent(false);

    recordPdfPrint('Error', error.detail.toString());
  }

  afterPrint = () => {
    document.body.classList.remove(SUPPORTED_PRINT_CLASS);

    this.delegate?.destroy();
    this.delegate = null;
  }
}
